export { default as UserEditForm } from './UserEditForm';
export { default as UserCreateForm } from './UserCreateForm';
export { default as UserPasswordChangeForm } from './UserPasswordChangeForm';



// WEBPACK FOOTER //
// ./src/modules/user/forms/index.js